import { overlay } from 'overlay-kit';

import { CreateBoardDialog } from './create-board-dialog';

export function requestCreateBoardDialog({
  onCreate,
}: {
  onCreate: (title: string) => Promise<void>;
}): Promise<void> {
  return overlay.openAsync<void>(({ isOpen, close, unmount }) => (
    <CreateBoardDialog
      isOpen={isOpen}
      onCancel={close}
      onCreate={async (title) => {
        await onCreate(title);
        close();
      }}
      onUnmount={unmount}
    />
  ));
}
